module.exports = __webpack_public_path__ + "static/img/EC@3x.6d038bb5.png";